import './styles.scss'

import React, { useState, useEffect } from 'react'
import { useActions, useValues } from 'kea'

import heartLogic from './logic'

export default function Heart () {
  const [favouriteChanged, setfavouriteChanged] = useState(false)
  const { toggleWishlistStatus } = useActions(heartLogic)
  const { isInWishlist, isToggling } = useValues(heartLogic)

  useEffect(() => {
    setfavouriteChanged(true)
  }, [isInWishlist])

  return (
    <div
      className={`single-wishlist-heart${favouriteChanged ? ' changed' : ''}${isInWishlist ? ' active' : ' inactive'}`}
      style={{ cursor: isToggling ? 'wait' : 'pointer' }}
      onClick={toggleWishlistStatus}
    />
  )
}
